import React, { useState, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import ActiveIcon from '../../assets/svg/active.svg';
import InActiveIcon from '../../assets/svg/inActive.svg';
import ViewIcon from '../../assets/svg/viewicon.svg';
import EditIcon from '../../assets/svg/pencil.svg';
import ExportIcon from '../../assets/svg/exportIconWhite.svg';
import DeleteIcon from '../../assets/svg/deleteWhiteIcon.svg';
import EmailIcon from '../../assets/svg/emailWhiteIcon.svg';
import StatusTag from '../../ReUsableComponent/StatusTag';
import DownloadIcon from '../../assets/svg/reportsDownload.svg';
import RetryIcon from '../../assets/svg/retryIcon.svg';
import { Tooltip } from "@mui/material";
import './CustomTableWithFilter.css';
import RedirectIcon from '../../assets/svg/redirectIcon.svg';
import { useHistory } from "react-router-dom";
import { InfoOutlined, Refresh } from "@mui/icons-material";

const CustomTableWithFilter = (props) => {

    const { onClickView, onClickEdit, onClickDelete, onClickDeletePromo, refGrid, handleActiveToggle, totalRow, layoutDom, refreshReports, filterModel, onClickDownloadReport, getRowStyle, onSelectionChanged, gotoReconReport, goToBrandReconReport, isContentLeftRightFixed = true, onClickDownloadFile, onClickViewPopup, onClickRetryFile, onClickEmailPromo, onMouseOver, onMouseOut } = props;
    const [isContentExceeds, setIsContentExceeds] = useState(false);
    const gridRef = useRef(null);
    const history = useHistory();
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        if (window.innerWidth >= 768) {
            if (gridRef.current) {
                const totalColumnWidth = props.column.reduce((sum, column) => sum + (column.width || 100), 0);
                const gridContainerWidth = gridRef.current.clientWidth;
                setIsContentExceeds(totalColumnWidth < gridContainerWidth);
            }
        }

    }, [props.column]);

    const customColumn = props.column.map((column, index) => {
        let pinned = null;
        if (window.innerWidth >= 768) {
            if (isContentLeftRightFixed) {
                if (index === 0) {
                    pinned = 'left';
                } else if (column.field === 'action' || column.field === 'feedbackAction' || column.field === 'targetAction' || column.field === 'employeeStatusaction' || column.field === 'promotionAction') {
                    pinned = 'right';
                }
            }
        }

        return {
            ...column,
            cellRenderer: (params) => {
                if (column.field === 'action' && column.actionFor === 'salesOverview') {
                    return (<div className="h100 actionBtnContainer">
                        <button title="View" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickView(params?.data?.id)}>
                            <img src={ViewIcon} alt="" />
                        </button>
                        <button title="Edit" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickEdit(params?.data?.id)}>
                            <img id="edit" src={EditIcon} alt="" />
                        </button>
                        <button style={{ padding: '4px 2px', }} className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickEdit(params?.data?.id)}>
                            <img id="edit" src={ExportIcon} alt="" />
                        </button>
                    </div>);
                } else if (column.field === 'action' && column.actionFor === 'rulesMangment') {
                    return (<div className="h100 actionBtnContainer">
                        <button title="Edit" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickEdit(params?.data?.id, params?.data?.index)}>
                            <img id="edit" src={EditIcon} alt="" />
                        </button>
                    </div>);
                } else if (column.field === 'action' && column.actionFor === 'file-center') {
                    return (
                      <div className="h100 actionBtnContainer">
                        <button
                          title="Download File"
                          className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                          onClick={() => onClickDownloadFile(params?.data?.id)}
                        >
                          <img src={DownloadIcon} alt="" />
                        </button>
                        {
                          <button
                            title="Retry File"
                            disabled={params.data.status !== "Failed"}
                            className={`tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn ${params.data.status !== "Failed" ? "disabled-icon" : ""}`}
                            onClick={() => {
                              if (params.data.status === "Failed") {
                                onClickRetryFile(params?.data?.id);
                              }
                            }}
                          >
                            <img src={RetryIcon} alt="" />
                          </button>
                        }
                      </div>
                    );
                } else if (column.field === 'action') {
                    return (<div className="h100 actionBtnContainer">
                        <button title="View" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickView(params?.data?.id)}>
                            <img src={ViewIcon} alt="" />
                        </button>
                        <button title="Edit" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickEdit(params?.data?.id)}>
                            <img id="edit" src={EditIcon} alt="" />
                        </button>
                        <button title="Enable/Disable" className="tableActionButtons d-flex align-items-center justify-content-center"
                            onClick={() => handleActiveToggle(params?.data)}>
                            <img src={params?.data?.status ? ActiveIcon : InActiveIcon} alt="" />
                        </button>
                        {column.actionFor === "reconReport-brandManagement" && (
                            <button
                                title="Goto Recon Reports"
                                className="tableActionButtons d-flex align-items-center justify-content-center"
                                style={{
                                    backgroundColor: '#f2f2f2',
                                    width: 'fit-content',
                                    border: '1px solid #f2f2f2',
                                    borderRadius: '30px',
                                    padding: '5px 5px 8px 8px'
                                }}
                                onClick={() => { goToBrandReconReport(params?.data?.id,params?.data.brandName);}}
                            >
                                <img src={RedirectIcon} alt="" />
                            </button>
                        )}

                    </div>);
                } else if (column.field === 'promotionAction') {
                    return (<div className="h100 actionBtnContainer">
                        <button title="View" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickView(params?.data?.id)}>
                            <img src={ViewIcon} alt="" />
                        </button>
                        <button title="Edit" className={`tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn `}
                            onClick={() => onClickEdit(params?.data?.id)}>
                            <img id="edit" src={EditIcon} alt="" />
                        </button>
                        <button className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickDeletePromo(params?.data?.id)}>
                            <img id="delete" src={DeleteIcon} alt="" style={{ width: '39px' }} />
                        </button>
                        <button className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickEmailPromo(params?.data?.id)}>
                            <img id="email" src={EmailIcon} alt="" style={{ width: '39px' }} />
                        </button>
                        {/* <button title="Edit" disabled={!params.data.status} className={`tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn ${!params.data.status ? 'opacity-50' : 'opacity-100'}`}
                            onClick={() => onClickEdit(params?.data?.id)}>
                            <img id="edit" src={EditIcon} alt="" />
                        </button> */}
                        {/* <button className="tableActionButtons d-flex align-items-center justify-content-center"
                            onClick={() => handleActiveToggle(params?.data)}>
                            <img src={params?.data?.status ? ActiveIcon : InActiveIcon} alt="" />
                        </button> */}
                    </div>);
                } else if (column.field === 'brandStatus' || column.field === 'reportStatus' || column.field === 'feedbackStatus' || column.field === 'profileStatus' || column.field === 'employeeSalesStatus') {
                    return <div className="tableStatusContainer">
                        {column.field === 'profileStatus' ? <StatusTag status={params?.data?.is_profile_completed ? 'Completed' : 'Incomplete'} /> : <StatusTag status={params.value} />}
                    </div>
                } else if (column.field === 'brandDeck') {
                    return <div>
                        <a href={params.value} target="_blank" rel="noreferrer">{params.value}</a>
                    </div>
                } else if (column.field === 'storeName' || column.field === 'brandName' || column.field === 'userName') {
                    return <button className="text-truncate cursor-pointer text-decoration-underline" title={params.value} onClick={() => onClickView(params?.data?.id)} >
                        {params.value}
                    </button>
                } else if ((column.field === 'passRecord') || column.field === 'errorRecord' || column.field === 'failedRecord') {
                    return <div className="h100 actionBtnContainer">
                        {params.value ? (<button title="Download" className={`tableActionButtons d-flex align-items-center justify-content-center ${column.field === 'passRecord' ? 'passReport' : column.field === 'errorRecord' ? 'errorReport' : 'failedReport'}`}
                            onClick={() => onClickDownloadReport(column.field, params, 'download', 'consolidated')}>
                            <img src={DownloadIcon} alt="" />
                        </button>) : 'NA'}
                        {column.field === 'passRecord' && column.for === 'sales' &&
                            <button title="Update Report" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn reset_filters_button"
                                style={{ backgroundColor: '#f2f2f2' }}
                                onClick={() => onClickDownloadReport(column.field, params, 'refresh', 'consolidated')}>
                                <Refresh className="RefreshOutlined" />
                            </button>}
                        {column.field === 'failedRecord' && <Tooltip arrow title={params.data.comment}>
                            <InfoOutlined />
                        </Tooltip>}
                    </div>
                } else if (column.field === 'ytdReport') {
                    return <div className="h100 actionBtnContainer">
                        <Tooltip arrow title="The yearly report will be updated 2 hours after the arrival of the new report in the system.">
                            <button title="Download" className={`tableActionButtons d-flex align-items-center justify-content-center passReport`}
                                onClick={() => onClickDownloadReport(column.field, params, 'download', 'ytd')}>
                                <img src={DownloadIcon} alt="" />
                            </button>
                        </Tooltip>
                        {/* {column.field === 'passRecord' && column.for === 'sales' && */}
                        {/* <button title="Update Report" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn reset_filters_button"
                            style={{ backgroundColor: '#f2f2f2' }}
                            onClick={() => onClickDownloadReport(column.field, params, 'refresh', 'ytd')}>
                            <Refresh className="RefreshOutlined" />
                        </button> */}
                        {/* } */}
                    </div>
                } else if (column.field === 'download') {
                    return <div className="h100 actionBtnContainer">
                        <button title="Download" className={`tableActionButtons d-flex align-items-center justify-content-center passReport`}
                            onClick={() => onClickDownloadReport(params)}>
                            <img src={DownloadIcon} alt="" />
                        </button>
                    </div>
                } else if (column.field === 'fileLink') {
                    return <div title={params.value} className="lh-base">
                        <button title="Download" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn passReport"
                            onClick={() => onClickDownloadReport(params)}>
                            <img src={DownloadIcon} alt="" />
                        </button>
                    </div>
                } else if (column.field === 'feedbackAction') {
                    return (<div className="h100 actionBtnContainer">
                        <button title="View" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickView(params?.data?.id)}>
                            <img src={ViewIcon} alt="" />
                        </button>
                    </div>);
                } else if (column.field === 'targetAction') {
                    return (<div className="h100 actionBtnContainer">
                        <button title="View" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickView(params?.data?.id)}>
                            <img src={ViewIcon} alt="" />
                        </button>
                        <button className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickDelete(params?.data?.id)}>
                            <img id="delete" src={DeleteIcon} alt="" style={{ width: '39px' }} />
                        </button>
                    </div>);
                } else if (column.field === 'image') {
                    return (<div className="zoom-icon-container">
                        <Tooltip arrow slotProps={{
                            popper: {
                                modifiers: [
                                    {
                                        name: 'offset',
                                        options: {
                                            offset: [0, -14],
                                        },
                                    },
                                ],
                            },
                        }} title={<img width={120} src={params.value} />}>
                            <img
                                src={params.value} width={24}
                                alt="cross icon"
                                className="zoom-icon"
                            />
                        </Tooltip>
                    </div>);
                } else if (column.field === 'barcode' || column.field === 'styleCode' || column.field === 'nameStore') {
                    return <span title={params.value} style={{ lineHeight: 1.3 }} >
                        {params.value}
                    </span>
                }
                else if (column.field === 'reconReport') {
                    return <div className="h100 actionBtnContainer">
                        <button title="Goto Recon Reports" className={`tableActionButtons d-flex align-items-center justify-content-center`} style={{
                            backgroundColor: '#f2f2f2', width: 'fit-content',
                            border: '1px solid #f2f2f2', borderRadius: '30px', padding: '8px 8px 10px 10px'
                        }}
                            onClick={() => gotoReconReport(params)}>
                            <img src={RedirectIcon} alt="" />
                        </button>
                    </div>
                } else if (column.field === 'reconFileViewDetails') {
                    return <div className="h100 actionBtnContainer">
                        <button onMouseEnter={(e) => onMouseOver?.(params?.data, e.currentTarget.getBoundingClientRect())}
                            onMouseLeave={() => onMouseOut?.(params?.data)}>
                            <InfoOutlined />
                        </button>
                    </div>
                } else if ((column.field === 'reconFileDownload' || column.field === 'ytdReconReport')) {
                    return <div className="h100 actionBtnContainer">
                        {column.field === 'ytdReconReport' && <Tooltip arrow title="The yearly report will be updated 2 hours after the arrival of the new report in the system.">
                            <button title="Download" className={`tableActionButtons d-flex align-items-center justify-content-center passReport`}
                                onClick={() => onClickDownloadReport(params, 'download')}>
                                <img src={DownloadIcon} alt="" />
                            </button>
                        </Tooltip>}
                        {column.field === 'reconFileDownload' &&
                            <>
                                <button title="Download" className={`tableActionButtons d-flex align-items-center justify-content-center passReport`}
                                    onClick={() => onClickDownloadReport(params, 'download')}>
                                    <img src={DownloadIcon} alt="" />
                                </button>
                                <button title="Update Report" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn reset_filters_button"
                                    style={{ backgroundColor: '#f2f2f2' }}
                                    onClick={() => onClickDownloadReport(params, 'refresh')}>
                                    <Refresh className="RefreshOutlined" />
                                </button>
                            </>}
                    </div>
                } else if ((column.field === 'employeeStatusaction')) {
                    return (<div className="h100 actionBtnContainer">
                        <button title="View" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickView(params?.data)}>
                            <img src={ViewIcon} alt="" />
                        </button>
                    </div>);
                } else if ((column.field === 'notiAction')) {
                    return (<div className="h100 actionBtnContainer">
                        <button title="Edit" className="tableActionButtons d-flex align-items-center justify-content-center viewAndEditBtn"
                            onClick={() => onClickEdit(params?.data)}>
                            <img src={EditIcon} alt="" />
                        </button>
                    </div>);
                } else if ((column.field === 'store_name')) {
                    return ViewStoreNameRenderer(params);
                } else if ((column.field === 'comment')) {
                    return <div title={params.value} className="text-truncate text-wrapper-to-next-line">
                        {params.value}
                    </div>
                }
                return <div title={params.value} className="text-truncate">
                    {params.value}
                </div>
            },
            pinned,
        }
    })
    const isExternalFilterPresent = () => true;
    const doesExternalFilterPass = () => true;

    const ViewStoreNameRenderer = (params) => {
        const isClickable = params.value?.includes(' + ');
        const matchedStores = params.data?.matchedStores || [];

        return (
            <div 
                title={isClickable ? matchedStores.join('\n') : params.value} 
                style={{ 
                    width: '100%',
                    maxWidth: '100%',
                    overflow: 'hidden'
                }}
            >
            <span 
                className={isClickable ? "text-primary text-decoration-underline" : ""}
                style={{ 
                    cursor: isClickable ? 'pointer' : 'default',
                    display: 'inline-block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    maxWidth: '100%', 
                      width: '100%',
                    verticalAlign: 'bottom'
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    if (isClickable) {
                        onClickViewPopup(params?.data);
                    }
                }}
            >
                {params.value}
            </span>
            </div>
        );
    };

    return (
        <div key={layoutDom ? layoutDom : ''} className={`customTable ag-theme-alpine ${props?.customeHeightClass}`} style={{ height: (layoutDom && layoutDom !== 'normal' ? 'max-content' : props.height ? props.height : 400), width: '100%' }}>
            <AgGridReact ref={refGrid ? refGrid : gridRef}
                columnDefs={customColumn}
                rowData={props.tableRowData}
                defaultColDef={props.filter}
                sortable
                onGridReady={props.onGridReady}
                onFilterChanged={props.onFilterChanged}
                onFirstDataRendered={props.onFirstDataRendered}
                initialFilterModel={props.initialFilterModel}
                filterModel={filterModel}
                onRowClicked={props.onRowClicked}
                tooltipShowDelay={0}
                getRowStyle={getRowStyle}
                suppressColumnMoveAnimation={true}
                suppressMovableColumns={true}
                onSelectionChanged={onSelectionChanged}
                suppressRowClickSelection={true}
                rowSelection="multiple"
                domLayout={layoutDom}
                pinnedBottomRowData={totalRow()}
                enableCellTextSelection={true}
                isExternalFilterPresent={isExternalFilterPresent}
                doesExternalFilterPass={doesExternalFilterPass}
            />
        </div>
    );
};

export default CustomTableWithFilter;
